import { useEffect, useMemo, useState } from 'react'
import { getKeyboardLayoutMap, LayoutMapType } from '~core/utils/keyboard'

export const useKeyboardLayoutMap = () => {
  const [keyboardLayout, setKeyboardLayout] = useState<LayoutMapType>()
  useEffect(() => {
    getKeyboardLayoutMap().then(setKeyboardLayout)
  }, [])
  return useMemo(() => keyboardLayout, [keyboardLayout])
}
